export {};
declare global {
	// eslint-disable-next-line no-unused-vars
	interface Window {
		gigya?: any;
	}
}

export const STATUS = {
	FAIL: "FAIL",
	OK: "OK",
};

export const RESPONSE_CODES = {
	SUCCESS: 0,
};

const gigyaActions = (screenSet: string, startScreen: string, onHide?: any) => {
	if (typeof window !== 'undefined' && window.gigya) {
		window.gigya.accounts.showScreenSet({
			screenSet: screenSet,
			startScreen: startScreen,
			onHide: onHide || null,
			deviceType: "auto",
		});
	} else {
		// Optionally handle the case where gigya is not loaded
		console.warn('Gigya SDK not loaded');
	}
};

export const login = (callback?: any): any => {
	gigyaActions("POC-FlujoComfamaID", "gigya-login-screen", callback);
	// gigyaActions("POC-RegistrationLogin", "gigya-login-screen", getUserData);
	// POC-RegistrationLoginID -> Login screen con estilos inestables
	// POC-RegistrationLogin -> Login screen con estilos un poco más estables
};

export const logout = () => {
	return new Promise((resolve, reject) => {
		if (typeof window !== 'undefined' && window.gigya) {
			window.gigya.accounts.logout({
				callback: (res: any) => {
					if (res.errorCode === RESPONSE_CODES.SUCCESS) resolve(res);
					else reject(res);
				},
			});
		} else {
			reject(new Error('Gigya SDK not loaded'));
		}
	});
};


export const getUserData = () => {
	return new Promise((resolve, reject) => {
		if (typeof window !== 'undefined' && window.gigya) {
			window.gigya.accounts.getAccountInfo({
				callback: (res: any) => {
					if (res.errorCode === RESPONSE_CODES.SUCCESS) resolve(res);
					else reject(res);
				},
			});
		} else {
			reject(new Error('Gigya SDK not loaded'));
		}
	});
};

export const verifySession = () => {
	return new Promise((resolve, reject) => {
		if (typeof window !== 'undefined' && window.gigya) {
			window.gigya.accounts.session.verify({
				callback: (res: any) => {
					if (res.errorCode === RESPONSE_CODES.SUCCESS) resolve(res);
					else reject(res);
				},
			});
		} else {
			reject(new Error('Gigya SDK not loaded'));
		}
	});
};

export const getLocalToken = () => {
	return localStorage.getItem("mentoria-token");
};

export const generateToken = () => {
	if (typeof window !== 'undefined' && window.gigya) {
		return window.gigya.accounts.getJWT({
			callback: (res: any) => {
				localStorage.setItem("mentoria-token", res);
				return res;
			},
			fields: "UID,data.docNumber,data.docType,data.mobile,email,firstName,lastName,photoURL",
			expiration: 604800,
		});
	} else {
		console.warn('Gigya SDK not loaded');
		return null;
	}
};
